import styled from 'styled-components';
import { color } from 'theme';
import { StyledFaqsSection } from '../shared/Faqs.styled';

export const StyledResistanceLanding = styled.div`
  ${StyledFaqsSection} {
    color: ${color('midnight_200')};
  }
`;
